// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { Beaker as RawBeaker } from "lucide-react";
export const Beaker = /* @__PURE__ */ createIcon(RawBeaker, "Beaker", 2);
